export default "__VITE_ASSET__CsGTYALj__"